
export function dataToFile (params) {
    let type = params.type;
    // 导出的文件名称
    let fileName = params.fileName;
    // 文件流数据
    let data = params.data;
    // 兼容 IE
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(new Blob([data]));
    } else {
        // 非IE 浏览器
        const url = window.URL.createObjectURL(new Blob([data], { type }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${fileName}`);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url); // 释放内存
    }
}

export default dataToFile;


// WEBPACK FOOTER //
// ./src/utils/dataToFile.js